module.exports = __webpack_public_path__ + "images/right-icon.96c82f960779e88bd8692a62c6a41789.png";